import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock } from "vue";
import App from '@/pages/data-screen/Screen.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'App',
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(App));
        };
    }
});
